import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProgramForm } from "../../components/Wallet/BuildCataloguePage";
import axios from "axios";

/* --------------------------------- Transaction Interfaces ------------------------------ */

export interface DistributorTransaction {
  transactionId: string;
  amount: number;
  transactionType: string;
  transactionTypeDisplay?: string;
  status: string;
  createdAt: string;
  debitDate?: string;
  settlementDate?: string;
  topUpDelta?: string | number;
  balanceDelta?: string | number;
  transactionNumber?: string;
  remark?: string;
  [key: string]: any;
}

export interface Transactions {
  total_count: number;
  transactions: DistributorTransaction[];
  page_size: number;
  page: number;
  current_balance: number;
  program_top_up: string;
  program_balance: string;
  program_remaining_top_up: string;
}

/* --------------------------------- Distributor Listing ------------------------------ */

interface Distributor {
  distributorId: number;
  name: string;
  updatedAt: string;
  creditLimit: number;
  isPurchaseOrderRequired: boolean;
  allowPurchaseOrderCreation: boolean;

}

export const fetchDistributors = createAsyncThunk("distributor/fetchDistributorList", async (name: null | string, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("accessToken");
    const params: any = {
      limit: 1000,
    };
    if (name) {
      params["name"] = name;
    }

    const response = await axios.request({
      baseURL: `${window.env.API_URL}/api/v1/distributorinternal`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "GET",
      params,
    });


    return response.data.rows;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data?.message || "Failed to fetch Recon Report");
  }
});

/* --------------------------------- Credit Distributor ------------------------------ */

export const creditDistributor = createAsyncThunk("distributor/creditDistributor", async ({ amount, distributorId, remark, transactionNumber, bankId, programId }: { amount: number | string; distributorId: any; remark: string; transactionNumber: string, bankId: string, programId: string }, { rejectWithValue, dispatch }) => {
  try {
    const token = localStorage.getItem("accessToken");
    console.log(distributorId, "distributorId lknj");
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/api/v1/distributorinternal/credit`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      data: {
        amount: amount,
        distributorId: distributorId,
        remark: remark,
        transactionNumber: transactionNumber,
        bankId: bankId,
        programId: programId,
      },
    });

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error?.response?.data?.message || "Failed to fetch Recon Report");
  }
});

/* --------------------------------- Email Unique Check ------------------------------ */

export const isEmailUnique = createAsyncThunk("distributor/isEmailUnique", async ({ email }: { email: string }, { rejectWithValue, dispatch }) => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await axios.request({
      baseURL: `${window.env.API_URL}/api/v1/auth/email`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "GET",
      params: {
        email
      }
    });
    return response.data;
  } catch (error: any) {
    console.log(error, error?.response?.data?.message, "kjbkbk");
    return rejectWithValue(error?.response?.data?.message || "Failed to fetch Recon Report");
  }
});


/* --------------------------------- Create Distributor ------------------------------ */

export const createDistributor = createAsyncThunk(
  "distributor/createDistributor",
  async (
    { name, businessName, hostname, paymentType, currency, country, email, password, contactInformation, isPurchaseOrderRequired, allowPurchaseOrderCreation }:
      { name: string; businessName: string; hostname: string; paymentType: number; currency: string; country: string; email: string; password: string; contactInformation: any; isPurchaseOrderRequired: boolean; allowPurchaseOrderCreation: boolean },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        data: {
          name,
          businessName,
          hostname,
          country,
          currency,
          paymentType,
          email,
          password,
          contactInformation,
          isPurchaseOrderRequired,
          allowPurchaseOrderCreation
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to create Distributor");
    }
  }
);

/* --------------------------------- Distributor Add Program ------------------------------ */

export const addProgramDistributor = createAsyncThunk("distributor/addProgramDistributor", async ({ distributorId, program }: { distributorId: string; program: ProgramForm }, { rejectWithValue, dispatch }) => {
  try {
    const token = localStorage.getItem("accessToken");

    const data = [];
    for (const item in program) {
      if (program[item].checked === false) continue;
      data.push({
        id: item,
        contractStartDate: program[item].contractStartDate,
        contractEndDate: program[item].contractEndDate,
        discountRanges: program[item].discount_ranges.map((range: any) => ({
          min_order_value: range.min_order_value,
          max_order_value: range.max_order_value,
          discount: range.discount
        }))
      });
    }

    const response = await axios.request({
      baseURL: `${window.env.API_URL}/api/v1/distributorinternal/addprograms`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        distributorId: distributorId,
      },
      method: "POST",
      data: {
        programIds: data,
      },
    });

    return response.data;
  } catch (error: any) {
    console.log(error, error?.response?.data?.message, "kjbkbk");
    return rejectWithValue(error?.response?.data?.message || "Failed to fetch Recon Report");
  }
});

/* --------------------------------- Get Distributor By ID ------------------------------ */
export const getDistributorById = createAsyncThunk(
  "distributor/getDistributorById",
  async (distributorId: number, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/cred`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          distributorId: distributorId,
        },
        method: "GET",
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to fetch distributor details");
    }
  }
);

/* --------------------------------- Update Distributor ------------------------------ */
export const updateDistributor = createAsyncThunk(
  "distributor/updateDistributor",
  async ({ distributorId, data }: { distributorId: number, data: FormData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          distributorId: distributorId,
        },
        method: "PUT",
        data
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to update distributor");
    }
  }
);

/* --------------------------------- Fetch Distributor Purchase Orders ------------------------------ */

export const fetchDistributorPurchaseOrders = createAsyncThunk(
  "distributor/fetchDistributorPurchaseOrders",
  async (
    { distributorId }: { distributorId: number },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/purchase-orders`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
        params: { distributorId },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to fetch purchase orders");
    }
  }
);

export const createPurchaseOrder = createAsyncThunk(
  "distributor/createPurchaseOrder",
  async (
    {
      distributorId,
      lineItems,
      invoice,
      remarks,
      clientOrderDate,
      clientPoNumber,
      receivedDate,
    }: {
      distributorId: number;
      lineItems: { programId: number; denominationAmount: number; quantity: number }[];
      invoice?: File | null;
      remarks: string;
      clientOrderDate: string;
      clientPoNumber: string;
      receivedDate: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("accessToken");
      const formData = new FormData();
      formData.append("distributorId", String(distributorId));
      formData.append("lineItems", JSON.stringify(lineItems));
      if (invoice) formData.append("invoice", invoice);
      formData.append("remarks", remarks);
      formData.append("clientOrderDate", clientOrderDate);
      formData.append("clientPoNumber", clientPoNumber);
      formData.append("receivedDate", receivedDate);
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/purchase-orders`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
        data: formData,
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to create purchase order");
    }
  }
);

/* --------------------------------- Fetch Distributor Transaction ------------------------------ */

// Async thunk to fetch distributor transactions
export const fetchDistributorTransaction = createAsyncThunk<
  Transactions, 
  { distributorId: number; page?: number; limit?: number; filterType?: string; search?: string; filterValue?: string; sortBy?: string; sortOrder?: string; programId?: string; transactionType?: string; forModal?: boolean }, 
  { rejectValue: string }
>(
  "distributor/fetchDistributorTransaction",
  async ({ distributorId, page, limit, filterType, search, filterValue, sortBy, sortOrder, programId, transactionType }, { rejectWithValue }) => {
    const token = localStorage.getItem('accessToken');
    
    try {
      let params: any = {};
      
      // Only add parameters if they are provided
      if (page) params["page"] = page;
      if (limit) params["limit"] = limit;
      if (sortBy) params["sortBy"] = sortBy;
      if (sortOrder) params["sortOrder"] = sortOrder;
      if (programId) params["programId"] = programId;
      if (search) params["search"] = search;
      if (filterType && filterValue) params[filterType] = filterValue;
      if (transactionType) params["transactionType"] = transactionType;

      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorportal/wallet`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          distributorid: distributorId,
        },
        method: "GET",
        params
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message?.statusCode || "Failed to fetch distributor transaction"
      );
    }
  }
);

/* --------------------------------- Wallet FY Summary ------------------------------ */

export interface WalletFySummaryDiscountRange {
  min_order_value: number;
  max_order_value: number | null;
  discount: number;
}

export interface WalletFySummaryItem {
  id: number;
  walletId: number;
  summaryId: number;
  closingBalance: number;
  totalFaceValue: number;
  totalTopUp: number;
  discountStructure: WalletFySummaryDiscountRange[];
  contractStartDate: string;
  contractEndDate: string;
  settlementStatus: number;
  financialYearStart: string;
  financialYearEnd: string;
  financialYearStatus: number;
  remark: string | null;
  closedAt: string;
  closedBy: number;
  createdAt: string;
  updatedAt: string;
}

export const fetchWalletFySummary = createAsyncThunk<
  WalletFySummaryItem[],
  { distributorId: number; walletId: number },
  { rejectValue: string }
>(
  "distributor/fetchWalletFySummary",
  async ({ distributorId, walletId }, { rejectWithValue }) => {
    const token = localStorage.getItem("accessToken");
    try {
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorportal/wallet-fy-summary`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          distributorid: distributorId,
        },
        method: "GET",
        params: { walletId },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message?.statusCode ||
          error?.response?.data?.message ||
          "Failed to fetch wallet FY summary"
      );
    }
  }
);

/* --------------------------------- Wallet FY Transactions ------------------------------ */

export interface WalletFyTransactionsResponse {
  total_count: number;
  transactions: DistributorTransaction[];
  page_size: number;
  current_page: number;
  total_pages: number;
}

export const fetchWalletFyTransactions = createAsyncThunk<
  WalletFyTransactionsResponse,
  {
    distributorId: number;
    walletId: number;
    fySummaryId: number;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: string;
  },
  { rejectValue: string }
>(
  "distributor/fetchWalletFyTransactions",
  async (
    { distributorId, walletId, fySummaryId, page = 1, limit = 10000, sortBy = "createdAt", sortOrder = "DESC" },
    { rejectWithValue }
  ) => {
    const token = localStorage.getItem("accessToken");
    try {
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorportal/wallet-fy-transactions`,
        timeout: 15000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          distributorid: distributorId,
        },
        method: "GET",
        params: { walletId, fySummaryId, page, limit, sortBy, sortOrder },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message?.statusCode ||
          error?.response?.data?.message ||
          "Failed to fetch wallet FY transactions"
      );
    }
  }
);

/* --------------------------------- Main State ------------------------------ */

export interface DistributorProgram {
  programId: number;
  programName: string;
  logo: string;
  ProgramDistributorWallet: {
    wallet_id: number;
    isActive?: boolean;
    discountRanges: {
      min_order_value: number;
      max_order_value: number | null;
      discount: number;
    }[];
    contractEndDate: string;
    contractStartDate: string;
    cumulativeBalance: string;
    cumulativeFaceValue: string;
    cumulativeTopUp: string;
  };
}

/* --------------------------------- FY Preview ------------------------------ */

export interface FYPreviewPayload {
  walletId: number;
  currentFyEndDate: string;
  newFyEndDate: string;
  newDiscountRanges: {
    min_order_value: number;
    max_order_value: number | null;
    discount: number;
  }[];
  remark?: string;
}

export interface FYPreviewResponse {
  closing_FY_balance: {
    closing_balance: number;
    total_face_value: number;
    total_top_up: number;
    discount_range: { min_order_value: number; max_order_value: number | null; discount: number }[];
    FY_start: string;
    FY_end: string;
    FY_status: number;
    remark?: string;
  };
  carried_FY_balance: {
    current_balance: number;
    cumulative_face_value: number;
    cumulative_top_up: number;
    discountPercentage: number;
  };
  new_FY_transactions: {
    creditTransactionAmt: number;
    debitTransactionAmt: number;
  };
  current_wallet_balance: {
    total_top_up: number;
    total_face_value: number;
    current_balance: number;
    new_contract_start_date: string;
    new_contract_end_date: string;
    new_discount_ranges: { min_order_value: number; max_order_value: number | null; discount: number }[];
  };
}

export interface FYCloseResponse {
  success: boolean;
  message: string;
  fySummary: {
    summaryId: number;
    walletId: number;
    closingBalance: number;
    totalFaceValue: number;
    totalTopUp: number;
    discountStructure: any[];
    contractStartDate: string;
    contractEndDate: string;
    settlementStatus: number;
    financialYearStart: string;
    financialYearEnd: string;
    financialYearStatus: number;
    remark?: string;
    closedAt: string;
    closedBy: number;
  };
  walletUpdate: {
    cumulativeTopUp: number;
    cumulativeFaceValue: number;
    cumulativeBalance: number;
    contractStartDate: string;
    contractEndDate: string;
  };
}

export const fetchFYPreview = createAsyncThunk(
  "distributor/fetchFYPreview",
  async (payload: FYPreviewPayload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/fy/preview`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        data: payload,
      });
      return response.data as FYPreviewResponse;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to fetch FY preview");
    }
  }
);

export const closeFY = createAsyncThunk(
  "distributor/closeFY",
  async (payload: FYPreviewPayload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/fy/close`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        data: payload,
      });
      return response.data as FYCloseResponse;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to close FY");
    }
  }
);

export interface RecalculateTransactionsPayload {
  walletId: number;
}

export const recalculateTransactions = createAsyncThunk(
  "distributor/recalculateTransactions",
  async (payload: RecalculateTransactionsPayload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/recalculate-transactions`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "POST",
        data: payload,
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || "Failed to recalculate transactions");
    }
  }
);

export interface SelectedDistributor {
  distributorId: number;
  userId: number;
  name: string;
  contactInformation: {
    email: string;
    phone: string;
    address?: {
      city: string;
      state: string;
      street: string;
      country: string;
      zipCode: string;
    };
    contactPerson: string;
  };
  apiCredentials: {
    apiKey: string;
    apiSecret: string;
  };
  creditLimit: number;
  totalVoucherSaleValue: number;
  totalCancellationValue: number;
  totalDepositsInWallet: number;
  whiteListedIps: string[];
  fulfilledByFincentive: boolean | null;
  isNonUniqueReferenceIdAllowed: boolean;
  paymentType: number;
  country: string | null;
  currency: string;
  businessName: string | null;
  hostname: string;
  createdAt: string;
  updatedAt: string;
  wallet: DistributorProgram[];
  paymentGatewayId: number | null;
  paymentGatewayConfig: Record<string, any>;
  logo_url?: string;
  theme?: {
    primary_color: string;
  } | null;
  isPurchaseOrderRequired: boolean;
  allowPurchaseOrderCreation: boolean;
 
}

// Types for Purchase Orders API response
export interface PurchaseOrderLineItem {
  purchaseOrderLineItemId: number;
  purchaseOrderId: number;
  programId: number;
  denominationAmount: string;
  quantity: number;
  remainingQuantity: number;
  usedQuantity: number;
  voucherRequestId: number | null;
  status: string;
  createdAt: string;
  updatedAt: string;
  purchase_order_id: number;
  program_id: number;
  voucher_request_id: number | null;
}

export interface PurchaseOrder {
  purchaseOrderId: number;
  purchaseOrderKey: string;
  clientPoNumber: string;
  clientOrderDate: string;
  receivedDate: string;
  distributorId: number;
  userId: number;
  status: string;
  remarks: string;
  invoice: string | null;
  createdAt: string;
  updatedAt: string;
  distributor_id: number;
  user_id: number;
  lineItems: PurchaseOrderLineItem[];
}

export interface PurchaseOrdersApiResponse {
  total_count: number;
  transactions: PurchaseOrder[];
  page_size: number;
  current_page: number;
  total_pages: number;
}

export interface ProgramPaymentGateway {
  programId: number;
  paymentGatewayId: number;
}

interface DistributorState {
  loading: boolean;
  error: any;
  distributorList: Distributor[] | null;
  selectedDistributor: SelectedDistributor | null;
  purchaseOrders: PurchaseOrdersApiResponse | null;
  transactions: Transactions | null;
  downloadingTransactions: boolean;
  selectedDistributorTransactions: Transactions | null;
  selectedDistributorTransactionsLoading: boolean;
  selectedDistributorTransactionsError: string | null;
  fyPreviewLoading: boolean;
  fyPreviewError: string | null;
  fyPreviewData: FYPreviewResponse | null;
  fyCloseLoading: boolean;
  fyCloseError: string | null;
  fyCloseSuccessMessage: string | null;
  walletFySummary: WalletFySummaryItem[] | null;
  walletFySummaryLoading: boolean;
  walletFySummaryError: string | null;
  recalculatingTransactions: boolean;
  recalculateTransactionsError: string | null;
  recalculateTransactionsSuccess: boolean;
  programPaymentGateways: ProgramPaymentGateway[] | null;
  notificationConfig: NotificationConfig | null;
  notificationConfigLoading: boolean;
  notificationConfigError: string | null;
  notificationConfigSaving: boolean;
  notificationConfigSaveError: string | null;
  notificationConfigSaveSuccess: boolean;
}

const initialState: DistributorState = {
  loading: false,
  error: null,
  distributorList: null,
  selectedDistributor: null,
  purchaseOrders: null,
  transactions: null,
  downloadingTransactions: false,
  selectedDistributorTransactions: null,
  selectedDistributorTransactionsLoading: false,
  selectedDistributorTransactionsError: null,
  fyPreviewLoading: false,
  fyPreviewError: null,
  fyPreviewData: null,
  fyCloseLoading: false,
  fyCloseError: null,
  fyCloseSuccessMessage: null,
  walletFySummary: null,
  walletFySummaryLoading: false,
  walletFySummaryError: null,
  recalculatingTransactions: false,
  recalculateTransactionsError: null,
  recalculateTransactionsSuccess: false,
  programPaymentGateways: null,
  notificationConfig: null,
  notificationConfigLoading: false,
  notificationConfigError: null,
  notificationConfigSaving: false,
  notificationConfigSaveError: null,
  notificationConfigSaveSuccess: false,
};

/* --------------------------------- Notification config (wallet threshold + alert contacts) ------------------------------ */

export interface NotificationAlertContact {
  distributorAlertContactId?: number;
  channel: "EMAIL" | "SMS";
  contactValue: string;
  alertTypes?: string[];
  isActive: boolean;
}

export interface NotificationConfig {
  distributorId: number;
  programId: number;
  walletId: number;
  thresholdBalance: number | null;
  cumulativeBalance: number;
  contacts: NotificationAlertContact[];
}

export interface UpsertNotificationConfigPayload {
  distributorId: number;
  programId: number;
  thresholdBalance?: number | null;
  contacts?: {
    channel: "EMAIL" | "SMS";
    contactValue: string;
    isActive?: boolean;
  }[];
}

export const fetchNotificationConfig = createAsyncThunk(
  "distributor/fetchNotificationConfig",
  async (
    { distributorId, programId }: { distributorId: number; programId: number },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/notifications/config`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
        params: { distributorId, programId },
      });
      return response.data as NotificationConfig;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch notification configuration"
      );
    }
  }
);

export const upsertNotificationConfig = createAsyncThunk(
  "distributor/upsertNotificationConfig",
  async (payload: UpsertNotificationConfigPayload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/notifications/config`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "PUT",
        data: payload,
      });
      return response.data as NotificationConfig;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to save notification configuration"
      );
    }
  }
);

/* --------------------------------- Distributor Program Payment Gateway ------------------------------ */

export const fetchDistributorProgramPaymentGateway = createAsyncThunk(
  "distributor/fetchDistributorProgramPaymentGateway",
  async (distributorId: number, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/distributor-program-pg`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          distributorid: distributorId,
        },
        method: "GET",
      });

      // API wraps data as { success: boolean, data: [...] }
      return response.data.data as ProgramPaymentGateway[];
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Failed to fetch distributor program payment gateway configuration"
      );
    }
  }
);

export const updateDistributorProgramPaymentGateway = createAsyncThunk(
  "distributor/updateDistributorProgramPaymentGateway",
  async (
    {
      distributorId,
      programPaymentGateways,
    }: {
      distributorId: number;
      programPaymentGateways: { programId: number; paymentGatewayId: number }[];
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios.request({
        baseURL: `${window.env.API_URL}/api/v1/distributorinternal/distributor-program-pg`,
        timeout: 10000,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          distributorid: distributorId,
        },
        method: "POST",
        data: {
          programPaymentGateways,
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Failed to update distributor program payment gateway configuration"
      );
    }
  }
);

const distributorWalletSlice = createSlice({
  name: "distributor",
  initialState,
  reducers: {
    clearDistributors(state) {
      state.distributorList = null;
      state.loading = false;
      state.error = null;
    },
    clearError(state) {
      state.error = null;
      state.loading = false;
    },
    clearFYPreview(state) {
      state.fyPreviewData = null;
      state.fyPreviewError = null;
      state.fyCloseError = null;
      state.fyCloseSuccessMessage = null;
    },
    clearNotificationConfig(state) {
      state.notificationConfig = null;
      state.notificationConfigLoading = false;
      state.notificationConfigError = null;
      state.notificationConfigSaving = false;
      state.notificationConfigSaveError = null;
      state.notificationConfigSaveSuccess = false;
    },
    clearNotificationConfigSaveStatus(state) {
      state.notificationConfigSaveError = null;
      state.notificationConfigSaveSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Distributor Listing
      .addCase(fetchDistributors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistributors.fulfilled, (state, action: PayloadAction<Distributor[]>) => {
        state.loading = false;
        state.distributorList = action.payload;
      })
      .addCase(fetchDistributors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch distributors";
      })

      // Credit Distributor
      .addCase(creditDistributor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(creditDistributor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to add credit";
      })

      // Create Distributor
      .addCase(createDistributor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDistributor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to add distributor";
      })

      // Distributor Add Program
      .addCase(addProgramDistributor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addProgramDistributor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to add programs to distributor";
      })
      .addCase(addProgramDistributor.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })

      // Get Distributor By ID
      .addCase(getDistributorById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDistributorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedDistributor = action.payload;
      })
      .addCase(getDistributorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Distributor
      .addCase(updateDistributor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDistributor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update distributor";
      })

      // Fetch Distributor Purchase Orders
      .addCase(fetchDistributorPurchaseOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistributorPurchaseOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.purchaseOrders = action.payload;
      })
      .addCase(fetchDistributorPurchaseOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch purchase orders";
      })

      // Fetch Distributor Transactions
      .addCase(fetchDistributorTransaction.pending, (state, action) => {
        if (action.meta.arg.forModal) {
          state.selectedDistributorTransactionsLoading = true;
          state.selectedDistributorTransactionsError = null;
        } else {
          state.downloadingTransactions = true;
          state.error = null;
        }
      })
      .addCase(fetchDistributorTransaction.fulfilled, (state, action) => {
        if (action.meta.arg.forModal) {
          state.selectedDistributorTransactionsLoading = false;
          state.selectedDistributorTransactions = action.payload;
        } else {
          state.downloadingTransactions = false;
          state.transactions = action.payload;
        }
      })
      .addCase(fetchDistributorTransaction.rejected, (state, action) => {
        if (action.meta.arg.forModal) {
          state.selectedDistributorTransactionsLoading = false;
          state.selectedDistributorTransactionsError = action.payload || "Failed to fetch distributor transactions";
        } else {
          state.downloadingTransactions = false;
          state.error = action.payload || "Failed to fetch distributor transactions";
        }
      })

      // FY Preview
      .addCase(fetchFYPreview.pending, (state) => {
        state.fyPreviewLoading = true;
        state.fyPreviewError = null;
      })
      .addCase(fetchFYPreview.fulfilled, (state, action) => {
        state.fyPreviewLoading = false;
        state.fyPreviewData = action.payload;
      })
      .addCase(fetchFYPreview.rejected, (state, action) => {
        state.fyPreviewLoading = false;
        state.fyPreviewError = action.payload as string || "Failed to fetch FY preview";
      })

      // FY Close
      .addCase(closeFY.pending, (state) => {
        state.fyCloseLoading = true;
        state.fyCloseError = null;
        state.fyCloseSuccessMessage = null;
      })
      .addCase(closeFY.fulfilled, (state, action: PayloadAction<FYCloseResponse>) => {
        state.fyCloseLoading = false;
        state.fyCloseSuccessMessage = action.payload.message || "Financial year closed successfully";
      })
      .addCase(closeFY.rejected, (state, action) => {
        state.fyCloseLoading = false;
        state.fyCloseError = (action.payload as string) || "Failed to close FY";
      })

      // Wallet FY Summary
      .addCase(fetchWalletFySummary.pending, (state) => {
        state.walletFySummaryLoading = true;
        state.walletFySummaryError = null;
      })
      .addCase(fetchWalletFySummary.fulfilled, (state, action: PayloadAction<WalletFySummaryItem[]>) => {
        state.walletFySummaryLoading = false;
        state.walletFySummary = action.payload;
      })
      .addCase(fetchWalletFySummary.rejected, (state, action) => {
        state.walletFySummaryLoading = false;
        state.walletFySummaryError = action.payload || "Failed to fetch wallet FY summary";
      })

      // Recalculate Transactions
      .addCase(recalculateTransactions.pending, (state) => {
        state.recalculatingTransactions = true;
        state.recalculateTransactionsError = null;
        state.recalculateTransactionsSuccess = false;
      })
      .addCase(recalculateTransactions.fulfilled, (state) => {
        state.recalculatingTransactions = false;
        state.recalculateTransactionsSuccess = true;
        state.recalculateTransactionsError = null;
      })
      .addCase(recalculateTransactions.rejected, (state, action) => {
        state.recalculatingTransactions = false;
        state.recalculateTransactionsError = (action.payload as string) || "Failed to recalculate transactions";
        state.recalculateTransactionsSuccess = false;
      })

      // Fetch Distributor Program Payment Gateway
      .addCase(fetchDistributorProgramPaymentGateway.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistributorProgramPaymentGateway.fulfilled, (state, action: PayloadAction<ProgramPaymentGateway[]>) => {
        state.loading = false;
        state.programPaymentGateways = action.payload;
      })
      .addCase(fetchDistributorProgramPaymentGateway.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to fetch distributor program payment gateway configuration";
      })

      // Update Distributor Program Payment Gateway
      .addCase(updateDistributorProgramPaymentGateway.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDistributorProgramPaymentGateway.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateDistributorProgramPaymentGateway.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to update distributor program payment gateway configuration";
      })

      // Notification config
      .addCase(fetchNotificationConfig.pending, (state) => {
        state.notificationConfigLoading = true;
        state.notificationConfigError = null;
      })
      .addCase(fetchNotificationConfig.fulfilled, (state, action: PayloadAction<NotificationConfig>) => {
        state.notificationConfigLoading = false;
        state.notificationConfig = action.payload;
      })
      .addCase(fetchNotificationConfig.rejected, (state, action) => {
        state.notificationConfigLoading = false;
        state.notificationConfigError =
          (action.payload as string) || "Failed to fetch notification configuration";
      })
      .addCase(upsertNotificationConfig.pending, (state) => {
        state.notificationConfigSaving = true;
        state.notificationConfigSaveError = null;
        state.notificationConfigSaveSuccess = false;
      })
      .addCase(upsertNotificationConfig.fulfilled, (state, action: PayloadAction<NotificationConfig>) => {
        state.notificationConfigSaving = false;
        state.notificationConfig = action.payload;
        state.notificationConfigSaveSuccess = true;
      })
      .addCase(upsertNotificationConfig.rejected, (state, action) => {
        state.notificationConfigSaving = false;
        state.notificationConfigSaveError =
          (action.payload as string) || "Failed to save notification configuration";
      });
  },
});

export const {
  clearDistributors,
  clearError,
  clearFYPreview,
  clearNotificationConfig,
  clearNotificationConfigSaveStatus,
} = distributorWalletSlice.actions;

export default distributorWalletSlice.reducer;